import React from 'react';
import { Box } from '@mui/material';

const DM = () => {
  return (
    <Box
      sx={{
        width: '100%',
        height: '600px',
        border: '1px solid #ccc',
        marginTop: '20px',
      }}
    >
      <iframe
        id="troveIframe"
        src="https://live.troveonline.in/app/memberChat"
        title="Trove Chat"
        style={{
          width: '100%',
          height: '100%',
          border: 'none',
        }}
      />
    </Box>
  )
}

export default DM
